import { toast } from "sonner";
import { http, formatApiError } from "@/lib/api";
import { Panel } from "@/components/admin/PageBits";
import { ReviewButtons } from "@/components/admin/CustomActionButtons";

export const DocumentReviewPanel = ({ req, onChanged }) => {
  const label = req.tipo === "PF" ? "CPF" : "CNPJ";
  const review = async (approve) => {
    try {
      await http.post(`/admin/requests/${req.id}/document/review`, { approve });
      toast.success(approve ? `${label} aprovado.` : `${label} recusado; o cliente deverá informar novamente.`);
      onChanged();
    } catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <Panel title={`Validação do ${label}`} testId="document-review-panel">
      <p className="text-sm text-sky-300">O cliente informou o {label} <span className="font-mono-x">{req.cnpj_fmt}</span> e está aguardando sua validação.</p>
      <ReviewButtons onReview={review} testPrefix="document" />
    </Panel>
  );
};
